<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title" >Fichas de partidos</v-toolbar-title>
    </v-toolbar>
    <FichasDePartidosSelector
      :torneos="torneos"
      @currentTournament="currentTournament"
      @tournamentSelection="handleTournamentClick"
      @extraTabSelection="handleExtraTabClick"
      @cleanHistoricSelectionMode="handleCleanHistoricSelectionModeClick"
      :historicTournamentSelectionMode="historicTournamentSelectionMode"
      :extraTabs="extraTabs"
      :urlTournamentAndFechaSelection="urlTournamentAndFechaSelection"
      :urlTournamentSelection="urlTournamentSelection"
    >
    </FichasDePartidosSelector>
    <SelectorFechas
      :historicTournamentSelectionMode="historicTournamentSelectionMode"
      :fechas="fechas"
      @fechaSelection="handleFechaClick"
      :urlTournamentAndFechaSelection="urlTournamentAndFechaSelection"
      :urlFechaSelection="urlFechaSelection"
      @offUrlSelection="handleOffUrlSelection"
    >
    </SelectorFechas>
    <div class="top-spacing">
      <router-view
        @selectedTorneoPath="handleSelectedTorneoPath"
        :titleRoute="titleRoute"
        ></router-view>
    </div>
  </div>
</template>

<script>
import FichasDePartidosSelector from '../components/FichasDePartidosSelector.vue'
import SelectorFechas from '../components/SelectorFechas.vue'
export default {

  components: {
    FichasDePartidosSelector,
    SelectorFechas
  },
  data () {
    return {
      fechas: [],
      torneos: [],
      partidos: [],
      categorias: [],
      temporadas: [],
      tournamentSelectionName: String,
      categorySelectionName: String,
      fechaSelectionName: String,
      seasonSelectionName: String,
      tournamentSelectionId: null,
      fechaSelectionId: null,
      categorySelectionId: null,
      seasonSelectionId: null,
      historicTournamentSelectionMode: false,
      extraTabs: [],
      historicTournament: {
        id: 'historicTournament',
        description: 'Histórico de torneos',
        historicTournament: true,
        tabType: 'historic',
        icon: 'fa-trophy'
      },
      tabFichaNavigation: [],
      urlTournamentAndFechaSelection: false,
      urlTournamentSelection: null,
      urlFechaSelection: null,
      titleRoute: null
    }
  },
  methods: {
    fetchTorneos () {
      this.axios
        .get(!this.historicTournamentSelectionMode
          ? `informe-auditoria/torneos?selector=true`
          : `informe-auditoria/torneos?seasonId=${this.seasonSelectionId}&categoryId=${this.categorySelectionId}&hasFechas=true&selector=true`)
        .then(response => {
          response.data.forEach(tournament => {
            if (this.historicTournamentSelectionMode) {
              this.extraTabs.push({ ...tournament, tabType: 'torneo', icon: 'fa-trophy' })
            } else if (tournament.activeTournament === true || tournament.id === this.urlTournamentSelection) {
              this.torneos.push({ ...tournament, tabType: 'torneo', icon: 'fa-trophy' })
            }
          })
          if (!this.historicTournamentSelectionMode) {
            this.torneos.push(this.historicTournament)
          }
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.$store.commit('setCustomErrorMsg', error.response.data.message)
          }
        })
    },
    fetchFechas () {
      this.axios
        .get(`informe-auditoria/fechas/current_fecha?torneo=${this.tournamentSelectionId}`)
        .then(response => {
          let currentFecha = response.data.currentFecha !== null ? response.data.currentFecha : false
          response.data.fechas.forEach(fecha => {
            if (currentFecha && fecha.id === currentFecha.id) {
              this.fechas.push({ id: fecha.id, description: fecha.nombreCompleto, current: true })
            } else {
              this.fechas.push({ id: fecha.id, description: fecha.nombreCompleto })
            }
          })
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchCategorias () {
      this.axios
        .get(`informe-auditoria/categorias?seasonId=${this.seasonSelectionId}&selector=true`)
        .then(response => {
          response.data.forEach(categoria => {
            this.extraTabs.push({ ...categoria, tabType: 'categoria', icon: 'fa-futbol' })
          })
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.$store.commit('setCustomErrorMsg', error.response.data.message)
          }
        })
    },
    fetchTemporadas () {
      this.axios
        .get('seasons?has_tournaments=true')
        .then(response => {
          response.data.forEach(temporada => {
            this.extraTabs.push({ ...temporada, tabType: 'temporada', icon: 'fa-flag' })
          })
          this.extraTabs.unshift(this.historicTournament)
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    handleTournamentClick (tournamentSelected) {
      if (tournamentSelected.historicTournament) {
        this.fetchTemporadas()
        this.historicTournamentSelectionMode = true
      } else {
        this.asignSelectedTournamentToComponentData(tournamentSelected)
      }
    },
    handleSeasonClick (seasonSelected) {
      this.seasonSelectionId = seasonSelected.id
    },
    handleCategoryClick (categorySelected) {
      this.categorySelectionId = categorySelected.id
    },
    currentTournament (tournament) {
      this.asignSelectedTournamentToComponentData(tournament)
    },
    handleFechaClick (fechaSelected) {
      if (fechaSelected) {
        this.fechaSelectionId = fechaSelected.id
        this.fechaSelectionName = fechaSelected.description
        this.urlTournamentAndFechaSelection = false
        this.$router.push({ name: 'fichaDePartidoFiltered', params: { torneoId: this.tournamentSelectionId, fechaId: this.fechaSelectionId } })
      }
    },
    handleExtraTabClick (extraTab) {
      if (extraTab.tabType === 'historic') {
        this.extraTabs = []
        this.tabFichaNavigation = []
        this.fetchTemporadas()
      }
      if (extraTab.tabType === 'torneo') {
        this.tabFichaNavigation.push(extraTab)
        this.torneos = []
        this.extraTabs = []
        this.extraTabs.unshift(
          this.tabFichaNavigation[0],
          this.tabFichaNavigation[1],
          this.tabFichaNavigation[2],
          extraTab
        )
        this.asignSelectedTournamentToComponentData(extraTab)
      }
      if (extraTab.tabType === 'temporada') {
        this.seasonSelectionId = extraTab.pk
        this.tabFichaNavigation.push(this.historicTournament)
        this.tabFichaNavigation.push(extraTab)
        this.extraTabs = []
        this.fetchCategorias()
        this.extraTabs.unshift(this.historicTournament, extraTab)
      }
      if (extraTab.tabType === 'categoria') {
        this.categorySelectionId = extraTab.id
        this.tabFichaNavigation.push(extraTab)
        this.torneos = []
        this.extraTabs = []
        this.fetchTorneos()
        this.extraTabs.unshift(this.tabFichaNavigation[0], this.tabFichaNavigation[1], extraTab)
      }
    },
    asignSelectedTournamentToComponentData (tournamentSelected) {
      if (tournamentSelected) {
        this.tournamentSelectionId = tournamentSelected.id
        this.tournamentSelectionName = tournamentSelected.description
        this.categorySelectionName = tournamentSelected.categoryName
        this.seasonSelectionName = tournamentSelected.seasonName
      }
    },
    handleCleanHistoricSelectionModeClick () {
      this.historicTournamentSelectionMode = false
      this.cleanSelection()
      this.fetchTorneos()
    },
    cleanSelection () {
      this.categorias = []
      this.categorySelectionId = null
      this.temporadas = []
      this.seasonSelectionId = null
      this.torneos = []
      this.extraTabs = []
    },
    handleSelectedTorneoPath (url) {
      this.urlTournamentAndFechaSelection = true
      this.urlTournamentSelection = url.torneo
      this.urlFechaSelection = url.fecha
    },
    handleOffUrlSelection () {
      this.urlTournamentAndFechaSelection = false
    }
  },

  mounted () {
    this.fetchTorneos()
  },
  watch: {
    async tournamentSelectionId () {
      if (this.tournamentSelectionId !== 'historicTournament') {
        this.fechas = []
        this.fetchFechas()
      }
    },
    async fechaSelectionId () {
      this.titleRoute = `${this.seasonSelectionName} > ${this.categorySelectionName} > ${this.tournamentSelectionName} > ${this.fechaSelectionName}`
    },
    '$route' () {
      if (this.$route.name === 'fichasDePartidos') {
        this.$router.go()
      }
    }
  }
}
</script>

<style scoped>
.top-spacing {
  margin-top: 5em;
}
.contenedor-fecha{
  padding: 0;
  margin: 0;
}
.contenedor-fechas{
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3), 5px 0px 0px 0px rgba(0,0,0,0.3), 0px 0px 0px 0px rgba(0,0,0,0.12) !important;
}
</style>
